module.exports = __webpack_public_path__ + "img/ic_tuition.5dcc99d7.svg";